import { dew as _constantsDew } from "../constants";
import { dew as _patternDew } from "../../../utils/pattern";
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _weekdaysDew } from "../../../common/calculation/weekdays";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const constants_1 = _constantsDew();
  const pattern_1 = _patternDew();
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const weekdays_1 = _weekdaysDew();
  const PATTERN = new RegExp("(?:(?:\\,|\\(|\\\uFF08)\\s*)?" + "(?:a[mn]\\s*?)?" + "(?:(diese[mn]|letzte[mn]|n(?:\xE4|ae)chste[mn])\\s*)?" + `(${pattern_1.matchAnyPattern(constants_1.WEEKDAY_DICTIONARY)})` + "(?:\\s*(?:\\,|\\)|\\\uFF09))?" + "(?:\\s*(diese|letzte|n(?:\xE4|ae)chste)\\s*woche)?" + "(?=\\W|$)", "i");
  const PREFIX_GROUP = 1;
  const SUFFIX_GROUP = 3;
  const WEEKDAY_GROUP = 2;
  class DEWeekdayParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      const dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
      const offset = constants_1.WEEKDAY_DICTIONARY[dayOfWeek];
      const prefix = match[PREFIX_GROUP];
      const postfix = match[SUFFIX_GROUP];
      let modifierWord = prefix || postfix;
      modifierWord = modifierWord || "";
      modifierWord = modifierWord.toLowerCase();
      let modifier = null;
      if (modifierWord.match(/letzte/)) {
        modifier = "last";
      } else if (modifierWord.match(/chste/)) {
        modifier = "next";
      } else if (modifierWord.match(/diese/)) {
        modifier = "this";
      }
      return weekdays_1.createParsingComponentsAtWeekday(context.reference, offset, modifier);
    }
  }
  exports.default = DEWeekdayParser;
  //# sourceMappingURL=DEWeekdayParser.js.map
  return exports;
}